"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EIP7412 = exports.DefaultAdapter = void 0;
const viem = __importStar(require("viem"));
const IERC7412_json_1 = __importDefault(require("../out/IERC7412.sol/IERC7412.json"));
const parseError_1 = require("./parseError");
var default_1 = require("./adapters/default");
Object.defineProperty(exports, "DefaultAdapter", { enumerable: true, get: function () { return default_1.DefaultAdapter; } });
class EIP7412 {
    constructor(adapters, multicallFunc) {
        this.adapters = new Map();
        adapters?.forEach((adapter) => {
            this.adapters.set(adapter.getOracleId(), adapter);
        });
        this.multicallFunc = multicallFunc;
    }
    async enableERC7412(client, tx) {
        const multicallCalls = Array.isArray(tx) ? tx : [tx];
        while (true) {
            try {
                if (multicallCalls.length == 1) {
                    await client.call(multicallCalls[0]);
                    return multicallCalls[0];
                }
                else if (!this.multicallFunc) {
                    throw 'multicallFunc is not defined';
                }
                else {
                    const multicallTxn = this.multicallFunc(multicallCalls);
                    await client.call(multicallTxn);
                    return multicallTxn;
                }
            }
            catch (error) {
                let err;
                try {
                    err = viem.decodeErrorResult({
                        abi: IERC7412_json_1.default.abi,
                        data: (0, parseError_1.parseError)(error),
                    });
                }
                catch (decodeErr) { }
                if (err?.errorName === 'OracleDataRequired') {
                    const oracleQuery = err.args[1];
                    const oracleAddress = err.args[0];
                    const oracleId = viem.hexToString(viem.trim((await client.readContract({
                        abi: IERC7412_json_1.default.abi,
                        address: oracleAddress,
                        functionName: 'oracleId',
                        args: [],
                    })), { dir: 'right' }));
                    const adapter = this.adapters.get(oracleId);
                    if (adapter === undefined) {
                        throw new Error(`oracle ${oracleId} not supported (supported oracles: ${Array.from(this.adapters.keys()).join(',')})`);
                    }
                    const signedRequiredData = await adapter.fetchOffchainData(client, oracleAddress, oracleQuery);
                    const priceUpdateTx = {
                        to: err.args[0],
                        data: viem.encodeFunctionData({
                            abi: IERC7412_json_1.default.abi,
                            functionName: 'fulfillOracleQuery',
                            args: [signedRequiredData],
                        }),
                    };
                    multicallCalls.unshift(priceUpdateTx);
                }
                else if (err?.errorName === 'FeeRequired') {
                    const requiredFee = err.args[0];
                    multicallCalls[0].value = requiredFee;
                }
                else {
                    throw error;
                }
            }
        }
    }
}
exports.EIP7412 = EIP7412;
//# sourceMappingURL=index.js.map